// extracted by mini-css-extract-plugin
export var bubble = "_13-0";
export var container = "_13-f";
export var contrastBorder = "_13-g";
export var greyOut = "_13-2";
export var initialsColor0 = "_13-3";
export var initialsColor1 = "_13-4";
export var initialsColor10 = "_13-d";
export var initialsColor11 = "_13-e";
export var initialsColor2 = "_13-5";
export var initialsColor3 = "_13-6";
export var initialsColor4 = "_13-7";
export var initialsColor5 = "_13-8";
export var initialsColor6 = "_13-9";
export var initialsColor7 = "_13-a";
export var initialsColor8 = "_13-b";
export var initialsColor9 = "_13-c";
export var initialsWrapper = "_13-1";
export var large = "_13-l";
export var medium = "_13-k";
export var mediumSmall = "_13-j";
export var mediumSmallMedium = "_13-o";
export var micro = "_13-h";
export var small = "_13-i";
export var tiny = "_13-n";
export var xTiny = "_13-m";